import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, Alert } from '@mui/material';

const DialogEditComponent = ({ open, onClose, onConfirm, fieldLabels, formValues, originalValues, showCalendarImpactNotice = false }) => (
  <Dialog open={open} onClose={onClose}>
    <DialogTitle>Confirmar modificación</DialogTitle>
    <DialogContent>
      <DialogContentText component="span">
        Está editando los datos del empleado con cédula: {formValues.ci}.
        <br /><br />
        ¿Está seguro de que desea modificar esta información?
        {showCalendarImpactNotice && (
          <>
            <br /><br />
            <Alert severity="info" sx={{ mb: 2 }}>
              Si el empleado participa en calendarios abiertos, esos calendarios también se actualizarán para reflejar estos cambios.
            </Alert>
          </>
        )}
        <ul>
          {Object.entries(formValues).map(([key, value]) => (
            originalValues[key] !== value && <li key={key}>{`${fieldLabels[key]}: ${originalValues[key]} -> ${value}`}</li>
          ))}
        </ul>
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} color="secondary">
        Cancelar
      </Button>
      <Button onClick={onConfirm} color="primary">
        Guardar
      </Button>
    </DialogActions>
  </Dialog>
);

export default DialogEditComponent;
